import {BsAndroid2, FaApple, FaWindows, FaLinux, TbArrowsExchange, TbCoinEuro,TbLock} from '../assets/icons/vander'

export const aboutData = [
    {
        icon:BsAndroid2,
        name:'Android',
        title:'Download'
    },
    {
        icon:FaApple,
        name:'IOS',
        title:'Download'
    },
    {
        icon:FaWindows,
        name:'windows',
        title:'Download'
    },
    {
        icon:FaLinux,
        name:'Linux',
        title:'Download'
    },
]
export const currencyData = [
    {
        name:'Bitcoin',
        title:'BTC',
        price:'$34587',
        perChange:'-2.5%',
        change:'-$745',
        marketCap:'$725,354M',
        status:'loss',
    },
    {
        name:'Litecoin',
        title:'LTC',
        price:'$216',
        perChange:'+.264%',
        change:'+$.264',
        marketCap:'$11,100M',
        status:'profit',
    },
    {
        name:'Auroracoin',
        title:'ARC',
        price:'$452',
        perChange:'-1.9%',
        change:'-$1.9',
        marketCap:'$45,785M',
        status:'loss',
    },
    {
        name:'Coinye',
        title:'CNY',
        price:'$154',
        perChange:'+1.05%',
        change:'+$1.05',
        marketCap:'$85,478M',
        status:'profit',
    },
    {
        name:'Ethereum Coin',
        title:'ETH',
        price:'$854',
        perChange:'+1.705%',
        change:'+$1.705',
        marketCap:'$112,452M',
        status:'profit',
    },
    {
        name:'Potcoin',
        title:'PTC',
        price:'$548',
        perChange:'-3.2%',
        change:'-$3.2',
        marketCap:'$4,712M',
        status:'loss',
    },
    {
        name:'Zcash Coin',
        title:'ZCC',
        price:'$965',
        perChange:'+1.465%',
        change:'+$1.465',
        marketCap:'$487,552M',
        status:'profit',
    },
    {
        name:'Prime coin',
        title:'XPM',
        price:'$4875',
        perChange:'-1.08%',
        change:'-$1.08',
        marketCap:'$55,221M',
        status:'loss',
    },
    {
        name:'Blocknet',
        title:'BLOCK',
        price:'$478',
        perChange:'+2.8%',
        change:'+$2.8',
        marketCap:'$66,552M',
        status:'profit',
    },
    {
        name:'Kucoin',
        title:'KCS',
        price:'$545',
        perChange:'+1.5%',
        change:'+$1.5',
        marketCap:'$98,562M',
        status:'profit',
    },
]

export const cryptoFeature = [
    {
        icon:TbArrowsExchange,
        title:'Easy to trade',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted."
    },
    {
        icon:TbCoinEuro,
        title:'Easy to sell & buy',
        desc:"The most well-known dummy text is the 'Lorem', which is said to have in."
    },
    {
        icon:TbLock,
        title:'Security',
        desc:"One disadvantage of Lorum Ipsum is that in certain letters appear more than."
    },
]